import { FamilyMemberInsurancePolicy } from 'core'

import { Button, Collapse, CollapseItem } from 'common/components'

import { DependentToEdit } from '..'
import Content from './Content'

import './styles.css'

export const enum DependentStatus {
  FullyCovered,
  PartlyCovered,
  NotCovered,
}

type Props = {
  firstName: string
  lastName: string
  familyMemberInsurancePolicies: FamilyMemberInsurancePolicy[]
  isCoveredForTheFullYear: boolean
  hasMultiplePolicies: boolean
  onEdit: (policy: DependentToEdit) => void
  onRemove: (id: string) => void
}

const DependantCollapsible = ({
  firstName,
  lastName,
  familyMemberInsurancePolicies,
  isCoveredForTheFullYear,
  hasMultiplePolicies = false,
  onEdit,
  onRemove,
}: Props) => {
  return (
    <Collapse className="design_classes_collapse bottom-border mb-16" defaultActiveKey={[0]}>
      <CollapseItem
        className="class_design dependent-collapsible__header"
        header={
          <div className="semi-bold">
            {firstName} {lastName}
          </div>
        }
        extra={
          !hasMultiplePolicies && (
            <>
              <Button
                onClick={(e) => {
                  e.stopPropagation()
                  onEdit(familyMemberInsurancePolicies[0])
                }}
              >
                Edit details
              </Button>

              <Button
                className="m-8"
                danger
                icon="far fa-trash-alt"
                onClick={(e) => {
                  e.stopPropagation()
                  onRemove(familyMemberInsurancePolicies[0].id)
                }}
              >
                Remove
              </Button>
            </>
          )
        }
        content={
          <Content
            firstName={firstName}
            lastName={lastName}
            familyMemberInsurancePolicies={familyMemberInsurancePolicies}
            isCoveredForTheFullYear={isCoveredForTheFullYear}
            hasMultiplePolicies={hasMultiplePolicies}
            onEdit={onEdit}
            onRemove={onRemove}
          />
        }
      />
    </Collapse>
  )
}

export default DependantCollapsible
